import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=a5db3dec&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"
import style0 from "./Campaigns.scss?vue&type=style&index=0&id=a5db3dec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5db3dec",
  null
  
)

export default component.exports